import style from "./OrderStatusDetail.module.css";

import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import AdminDateChoice from "../datePicker/AdminDateChoice";
import AdminTable from "../table/AdminTable";
import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { requester, adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "../table/SingleAdminTable";
import { useNavigate, useParams } from "react-router-dom";
import { timers } from "jquery";
import TableButton from "../table/TableButton";
import { t } from "i18next";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import {
  getLineItems,
  getOrdersExcelOutput,
  getShipExcelOutput,
  getTaxExcelOutput,
} from "./OrderToExcel";
import FlexGrid from "layouts/flex/FlexGrid";
import P from "components/P";
import AdminCustomButton, {
  style as buttonStyle,
} from "components/buttons/AdminCustomButton";
import InputTextarea from "components/inputs/InputTextarea";
import _ from "lodash";
import ToolTip from "components/tooltip/tooltip";
import NiceModal from "@ebay/nice-modal-react";
import { toast } from "react-toastify";

function OrderStatusDetail(props) {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const { keyword } = useParams();
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const [extraCondition, setExtraCondition] = useState({});
  const [views, setViews] = useState([]);
  const [outputHeader, setOutputHeader] = useState([]);
  const [theader, setTheader] = useState([]);
  const [outs, setOuts] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const [limit, setLimit] = useState(20);
  const navigator = useNavigate();

  useEffect(() => {
    adminRequester.getOrderStatus(
      {
        // keyword: keyword,
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setData(result.orders);
        setMaxPage(result.count / limit);
        setCount(result.count);
      }
    );
  }, [page, searchCondition]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getOrderStatus(
        {
          // keyword: keyword,
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setData(result.orders);
          setMaxPage(result.count / limit);
          setCount(result.count);
        }
      );
      setResearch(false);
    }
  }, [research]);
  useEffect(() => {
    let indexes = [];
    let buttons = [];
    switch (keyword) {
      case "WaitingForPayment": {
        indexes = [0, 1, 2, 3, 10, 11, 6, 13, 21, 9];
        const outputHeader = [0, 1, 2, 3, 9, 10, 6, 11];
        buttons = [
          { code: "reset_moeny" },
          { code: "capture" },
          { code: "order_cancel" },
        ];
        setViews(["WaitingForPayment"]);
        setExtraCondition({
          order_status: "pending,completed",
          payment_status: "awaiting",
          fulfillment_status:
            "not_fulfilled,fulfilled,partially_shipped,shipped",
        });
        setOutputHeader(outputHeader.map((index) => outputHeaderList[index]));
        break;
      }
      case "ReadyForProduct": {
        indexes = [0, 1, 2, 22, 3, 6, 13, 20, 21];
        // const outputHeader = [0, 1, 2, 3, 6, 12, 13];
        buttons = [{ code: "ship_ready" }, { code: "refund" }];
        setViews(["ReadyForProduct"]);
        setExtraCondition({
          order_status: "pending",
          payment_status: "captured",
          fulfillment_status: "not_fulfilled",
        });
        setOutputHeader([]);
        break;
      }
      case "ReadyForShipment": {
        indexes = [0, 1, 2, 3, 6, 13, 20, 8, 9];
        buttons = [
          {
            code: "excelUpload",
            onSuccess: (list) =>
              Promise.all(
                list?.map(async (data) => {
                  const { order } = await adminRequester.getOrder(data.id);

                  await adminRequester.updateOrderStatus(order.id, {
                    metadata: _.merge(order.metadata, {
                      shipping: data.shipping,
                    }),
                  });
                })
              ).then(() => setResearch(true)),
            props: {
              label: "송장 일괄 업로드",
              header: [
                { code: "고객주문번호", attr: "id" },
                { code: "운송장번호", attr: "shipping" },
              ],
            },
          },
          { code: "shipping" },
          { code: "product_ready" },
          {
            code: "refund",
          },
        ];
        setViews(["ReadyForShipment"]);
        setExtraCondition({
          order_status: "pending",
          payment_status: "captured",
          fulfillment_status: "fulfilled",
        });
        setOutputHeader([]);
        break;
      }
      case "Shipping": {
        indexes = [0, 1, 2, 3, 6, 14, 20, 8, 9];
        buttons = [
          { code: "ship_complete" },
          { code: "ship_ready" },
          { code: "product_ready" },
        ];
        setViews(["Shipping"]);
        setExtraCondition({
          order_status: "pending",
          payment_status: "captured",
          fulfillment_status: "partially_shipped",
        });
        setOutputHeader([]);
        break;
      }
      case "DeliveryCompleted": {
        indexes = [0, 1, 2, 3, 6, 14, 20, 8, 9];
        buttons = [{ code: "shipping" }, { code: "exchange" }];
        setViews(["DeliveryCompleted"]);
        setExtraCondition({
          order_status: "completed",
          payment_status: "captured",
          fulfillment_status: "shipped",
        });
        setOutputHeader([]);
        break;
      }
      case "CanceledOrder": {
        indexes = [17, 1, 2, 3, 16, 15, 5, 9];
        buttons = [
          { code: "allowOrderCancel" },
          { code: "canceledOrderCancel" },
        ];
        setViews(["CanceledOrder", "ExchangeOrder", "RefundOrder"]);
        setExtraCondition({
          order_status: "canceled",
          payment_status: "awaiting,canceled",
          fulfillment_status: "canceled",
        });
        setOutputHeader([]);
        break;
      }
      case "ExchangeOrder": {
        indexes = [18, 1, 2, 3, 16, 15, 5, 9];
        buttons = [{ code: "return" }, { code: "canceledExchange" }];
        setViews(["CanceledOrder", "ExchangeOrder", "RefundOrder"]);
        setExtraCondition({
          order_status: "exchange",
          payment_status: "captured",
          fulfillment_status:
            "not_fulfilled,returned,partially_returned,shipped",
        });
        setOutputHeader([]);
        break;
      }
      case "RefundOrder": {
        indexes = [19, 1, 2, 3, 16, 15, 5, 9];
        buttons = [{ code: "return" }, { code: "canceledRefund" }];
        setViews(["CanceledOrder", "ExchangeOrder", "RefundOrder"]);
        setExtraCondition({
          order_status: "refund",
          payment_status: "awaiting,captured",
          fulfillment_status: "not_fulfilled,returned,not_fulfilled,shipped",
        });
        setOutputHeader([]);
        break;
      }
      default: {
        indexes = [0, 1, 2, 3, 4, 6, 7, 8, 21, 9];
        const outputHeader = [0, 1, 2, 3, 4, 5, 6, 7, 8];
        setViews(["AllOrder"]);
        setExtraCondition([]);
        setOutputHeader(outputHeader.map((index) => outputHeaderList[index]));
        break;
      }
    }
    setButtons(
      buttons
        .map((button) =>
          TableButton(
            button.code,
            button?.onSuccess ? button.onSuccess : () => setResearch(true),
            button?.props
          )
        )
        .filter((button) => !!button)
    );
    setTheader(
      indexes.map((index) => {
        const theader = theaderList[index];
        if (!theader?.onClick) return { ...theader, onClick: openDetail };
        return theader;
      })
    );
    setReset(true);
  }, [keyword]);
  useEffect(() => {
    switch (keyword) {
      case "ReadyForProduct": {
        setOuts([
          getShipExcelOutput({
            extraCondition: extraCondition,
            searchCondition: searchCondition,
            onSuccess: () => setResearch(true),
          }),
          getLineItems({
            extraCondition: extraCondition,
            searchCondition: searchCondition,
            onSuccess: () => setResearch(true),
          }),
        ]);
        break;
      }
      case "ReadyForShipment": {
        const output1 = getShipExcelOutput({
          extraCondition: extraCondition,
          searchCondition: searchCondition,
          onSuccess: () => setResearch(true),
        });
        const output2 = getTaxExcelOutput({
          extraCondition: extraCondition,
          searchCondition: searchCondition,
          onSuccess: () => setResearch(true),
        });
        setOuts([
          output1,
          output2,
          // {
          //   getData: getOutput(outputHeader),
          // },
          getLineItems({
            extraCondition: extraCondition,
            searchCondition: searchCondition,
            onSuccess: () => setResearch(true),
          }),
        ]);
        break;
      }
      case "Shipping":
      case "AllOrder": {
        setOuts([
          getLineItems({
            extraCondition: extraCondition,
            searchCondition: searchCondition,
            onSuccess: () => setResearch(true),
          }),
          getOrdersExcelOutput({
            extraCondition: extraCondition,
            searchCondition: searchCondition,
            onSuccess: () => setResearch(true),
          }),
        ]);
        break;
      }
      default: {
        setOuts(
          getLineItems({
            extraCondition: extraCondition,
            searchCondition: searchCondition,
            onSuccess: () => setResearch(true),
          })
        );
        break;
      }
    }
  }, [outputHeader, extraCondition, searchCondition]);
  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };

  const getDate = (date) => {
    date = new Date(date);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  const theaderList = [
    {
      width: 140,
      text: "주문일(결제일)",
      justifyContent: "flex-start",
      Cell: ({ row }) =>
        `${getDate(row.created_at)}\n(${
          row?.payments?.length > 0 && row?.payment_status !== "awaiting"
            ? getDate(row?.payments?.[0]?.updated_at)
            : "결제정보없음"
        })`,
      index: "0",
    },
    {
      width: 150,
      text: "주문번호",
      justifyContent: "flex-start",
      code: "id",
      style: { wordBreak: "break-all" },
      index: "1",
    },
    {
      width: 150,
      text: "주문자",
      justifyContent: "flex-start",
      code: "customer",
      ellipsis: true,
      Cell: ({ cell }) => (
        <P>
          {`${cell?.first_name && cell.first_name}${
            cell?.first_name && cell?.last_name ? " " : ""
          }${cell?.last_name ? cell.last_name : ""}\n(${cell.email})`}
        </P>
      ),

      index: "2",
    },
    {
      width: 450,
      text: "상품명",
      justifyContent: "flex-start",
      code: "items",
      Cell: ({ cell }) => (
        <FlexGrid columns={2} width="max-content" gap={10} rows={cell.length}>
          {cell
            ?.reduce((acc, item) => {
              item = {
                ...item,
                quantity: item.free ? 0 : item.quantity,
                extra: item.free ? item.quantity : 0,
                free: null,
              };
              const find = acc.find((f) => f.variant_id === item.variant_id);
              if (find) {
                find.quantity = Number(find.quantity) + Number(item.quantity);
                find.extra = Number(find.extra) + Number(item.extra);
                return acc;
              }
              return [...acc, item];
            }, [])
            .sort((a1, a2) =>
              a1?.variant?.product?.title
                // .replace("[월드]", "").replace(" ", "")
                .localeCompare(
                  a2?.variant?.product?.title
                  // .replace("[월드]", "").replace(" ", "")
                )
            )
            ?.map((item) => (
              <>
                <FlexChild width={400} key={`${item.id}_title`}>
                  <HorizontalFlex
                    width="max-content"
                    justifyContent="flex-start"
                  >
                    {item.extra > 0 ? (
                      <P color="#09B3F5">(증정 포함) </P>
                    ) : (
                      <></>
                    )}
                    <P>{`${item?.title} ${item.variant?.title}`}</P>
                  </HorizontalFlex>
                </FlexChild>
                <FlexChild width={50} key={`${item.id}_quantity`}>
                  <HorizontalFlex
                    width={"max-content"}
                    justifyContent="flex-start"
                  >
                    <P>{`x ${item.quantity}`}</P>
                    {item.extra > 0 ? (
                      <P color="#09B3F5"> + {item.extra}</P>
                    ) : (
                      <></>
                    )}
                  </HorizontalFlex>
                </FlexChild>
              </>
            ))}
        </FlexGrid>
      ),
      index: "3",
    },
    {
      width: 80,
      text: "구매금액",
      justifyContent: "flex-start",
      code: "payments",
      Cell: ({ cell }) => cell?.[0]?.amount || 0,
      index: "4",
    },
    {
      width: 150,
      text: "결제수단",
      justifyContent: "center",
      Cell: () => (
        <VerticalFlex gap={5}>
          <AdminCustomButton style={buttonStyle.white_border} text="신용카드" />
          <AdminCustomButton style={buttonStyle.white_border} text="무통장" />
        </VerticalFlex>
      ),
      index: "5",
    },
    {
      width: 150,
      text: "결제 상태",
      justifyContent: "flex-start",
      code: "payment_status",
      Cell: ({ cell }) => t(cell),
      index: "6",
    },
    {
      width: 150,
      text: "배송 상태",
      justifyContent: "flex-start",
      code: "fulfillment_status",
      Cell: ({ cell }) => t(cell),
      index: "7",
    },
    {
      width: 120,
      text: "운송장번호",
      code: "metadata",
      Cell: ({ cell }) => (
        <P hover cursor>
          {cell?.shipping ? cell.shipping : "데이터 없음"}
        </P>
      ),
      onClick: ({ cell }) => {
        const trackingNumber = cell?.shipping; // 운송장 번호 가져오기
        if (!trackingNumber) {
          toast.error(t("운송장 번호가 존재하지 않습니다."), {
            autoClose: 1000,
            position: toast.POSITION.BOTTOM_CENTER,
          });
          return;
        } else {
          const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber.replaceAll(
            "-",
            ""
          )}`;

          // 팝업창 옵션 설정
          const popupOptions =
            "width=800,height=800,scrollbars=yes,resizable=yes";

          // 팝업창 열기
          window.open(trackingUrl, "ShippingStatusPopup", popupOptions);
        }
      },
      justifyContent: "flex-start",
      index: "8",
    },
    {
      width: 200,
      text: "메모",
      justifyContent: "flex-start",
      code: "metadata",
      Cell: ({ row, cell }) => (
        <Memo row={row} cell={cell} setResearch={setResearch} />
      ),
      onClick: () => {},
      index: "9",
    },
    {
      width: 80,
      text: "입금액",
      justifyContent: "flex-start",
      code: "customer",
      Cell: ({ cell }) => Number(cell?.metadata?.amount) || 0,
      index: "10",
    },
    {
      width: 80,
      text: "입금은행",
      justifyContent: "center",
      Cell: () => (
        <VerticalFlex gap={5}>
          <FlexChild>
            <AdminCustomButton style={buttonStyle.white_border} text="무통장" />
          </FlexChild>
          <FlexChild>
            <AdminCustomButton
              style={buttonStyle.white_border}
              text="국민은행"
            />
          </FlexChild>
        </VerticalFlex>
      ),
      index: "11",
    },
    {
      width: 80,
      text: "추가입금",
      justifyContent: "center",
      Cell: () => "-",
      index: "12",
    },
    {
      width: 80,
      text: "총 결제금액",
      justifyContent: "flex-start",
      code: "payments",
      Cell: ({ cell }) => cell?.[0]?.amount || 0,
      index: "13",
    },
    {
      width: 140,
      text: "배송일",
      justifyContent: "flex-start",
      code: "metadata",
      Cell: ({ cell }) => getDate(cell?.shipping_date),
      index: "14",
    },
    {
      width: 100,
      text: "진행상황",
      index: "15",
      Cell: ({ row }) => {
        if (
          row.status === "canceled" &&
          row.fulfillment_status === "canceled"
        ) {
          return row.payment_status === "canceled" ? "취소완료" : "취소신청";
        } else if (
          row.status === "exchange" &&
          row.payment_status === "captured"
        ) {
          switch (row.fulfillment_status) {
            case "not_fulfilled":
              return "교환신청";
            case "returned":
              return "반품 완료";
            case "partially_returned":
              return "교환품 지급/수거 전";
            case "shipped":
              return "교환완료";
            default:
              break;
          }
        } else if (row.status === "refund") {
          const status =
            (row.payment_status === "awaiting" ? 0 : 1) +
            (row.fulfillment_status === "not_fulfilled" ? 0 : 2);
          switch (status) {
            case 0:
              return "환불 신청";
            case 1:
              return "반품 완료";
            case 2:
              return "환불금 지급/수거 전";
            case 3:
              return "환불 완료";
            default:
              break;
          }
        }
        return "-";
      },
    },
    {
      width: 100,
      text: "결제 예정 금액",
      justifyContent: "flex-start",
      code: "payments",
      Cell: ({ cell }) => cell?.[0]?.amount || 0,
      index: "16",
    },
    {
      width: 140,
      text: "주문일(취소일)",
      justifyContent: "flex-start",
      Cell: ({ row }) =>
        `${getDate(row?.created_at)}\n(${
          row.canceled_at ? getDate(row.canceled_at) : "결제정보없음"
        })`,
      index: "17",
    },
    {
      width: 140,
      text: "주문일(교환일)",
      justifyContent: "flex-start",
      Cell: ({ row }) =>
        `${getDate(row?.created_at)}\n(${
          row?.fulfillments?.length > 0 &&
          row?.fulfillments?.[row?.fulfillments?.length - 1]
            ? getDate(
                row?.fulfillments?.[row?.fulfillments?.length - 1].canceled_at
              )
            : "결제정보없음"
        })`,
      index: "18",
    },
    {
      width: 140,
      text: "주문일(환불일)",
      justifyContent: "flex-start",
      Cell: ({ row }) =>
        `${getDate(row?.created_at)}\n(${
          row?.payments?.length > 0 &&
          row?.payments?.[row?.payments?.length - 1]
            ? getDate(row.payments?.[row?.payments?.length - 1].canceled_at)
            : "결제정보없음"
        })`,
      index: "19",
    },
    {
      width: 140,
      text: "배송정보",
      justifyContent: "flex-start",
      code: "shipping_address",
      Cell: ({ row, cell }) => (
        <ToolTip
          style={{
            zIndex: 10,
            width: "max-content",
            padding: 10,
            backgroundColor: "white",
            border: "1px solid black",
          }}
          title={
            <VerticalFlex
              backgroundColor="white"
              // width={300}
              flexStart
              padding={10}
            >
              <P width="max-content">
                {`${cell?.company ? cell.company : ""}${
                  cell?.company &&
                  cell?.company !== "default" &&
                  (cell?.first_name || cell?.last_name)
                    ? " "
                    : ""
                }${
                  cell?.first_name || cell?.last_name
                    ? `${cell?.first_name && cell.first_name}${
                        cell.first_name && cell.last_name ? " " : ""
                      }${cell.last_name ? cell.last_name : ""}`
                    : ""
                }`.replace("default ", "")}
              </P>
              <P>
                {`${cell?.postal_code ? `(${cell.postal_code})` : ""}${
                  cell?.postal_code && (cell?.address_1 || cell.address_2)
                    ? " "
                    : ""
                }${cell?.address_1 ? cell.address_1 : ""}${
                  cell.address_1 && cell.address_2 ? " " : ""
                }${cell?.address_2 ? cell.address_2 : ""}`}
              </P>
            </VerticalFlex>
          }
        >
          <VerticalFlex>
            <P ellipsis width={140}>
              {`${cell?.company ? cell.company : ""}${
                cell?.company && (cell?.first_name || cell?.last_name)
                  ? " "
                  : ""
              }${
                cell?.first_name || cell?.last_name
                  ? `${cell?.first_name && cell.first_name}${
                      cell.first_name && cell.last_name ? " " : ""
                    }${cell.last_name ? cell.last_name : ""}`
                  : ""
              }`.replace("default ", "")}
            </P>
            <P ellipsis width={140}>
              {`${cell?.postal_code ? `(${cell.postal_code})` : ""}${
                cell?.postal_code && (cell?.address_1 || cell.address_2)
                  ? " "
                  : ""
              }${cell?.address_1 ? cell.address_1 : ""}${
                cell.address_1 && cell.address_2 ? " " : ""
              }${cell?.address_2 ? cell.address_2 : ""}`}
            </P>
          </VerticalFlex>
        </ToolTip>
      ),
      index: "20",
    },
    {
      width: 220,
      text: "배송메시지",
      code: "message",
      Cell: ({ cell }) => (cell ? cell : "없음"),
      index: "21",
    },
    {
      width: 80,
      text: "등급",
      code: "customer",
      Cell: ({ cell }) => cell?.groups?.[0]?.name || "사업자회원",
      index: "22",
    },
  ];
  const outputHeaderList = [
    {
      text: "주문일(결제일)",
      Cell: ({ row }) =>
        `${getDate(row?.created_at)}\n(${
          row?.payments?.length > 0 && row?.payment_status !== "awaiting"
            ? getDate(row?.payments?.[0]?.updated_at)
            : "결제정보없음"
        })`,
      index: "0",
    },
    {
      text: "주문번호",
      code: "id",
      index: "1",
    },
    {
      text: "주문자",
      code: "customer",
      Cell: ({ cell }) =>
        `${cell?.first_name ? cell.first_name : ""}${
          cell?.first_name && cell.last_name ? " " : ""
        }${cell?.last_name ? cell.last_name : ""}\n(${
          cell?.email ? cell.email : ""
        })`,
      style: {
        common: {
          alignment: { wrapText: true },
        },
      },
      index: "2",
    },
    {
      text: "상품명",
      code: "items",
      Cell: ({ cell }) =>
        Array.sort(cell, (a1, a2) =>
          a1.variant.product.title.localeCompare(a2.variant.product.title)
        )
          ?.map(
            (item) =>
              `${item.free ? "(증정)" : ""} ${item.title} ${
                item.variant.title
              } x ${item.quantity}` //`${item.product.brand.title} ${item.product.title}`
          )
          .join("\n"),
      style: {
        common: {
          alignment: { wrapText: true },
        },
      },
      index: "3",
    },
    {
      text: "구매금액",
      code: "payments",
      Cell: ({ cell }) => cell?.[0]?.amount || 0,
      index: "4",
    },
    {
      text: "결제수단",
      Cell: () => `신용카드 / 무통장`,
      index: "5",
    },
    {
      text: "결제 상태",
      code: "payment_status",
      Cell: ({ cell }) => t(cell),
      index: "6",
    },
    {
      text: "배송 상태",
      code: "fulfillment_status",
      Cell: ({ cell }) => t(cell),
      index: "7",
    },
    {
      text: "운송장 번호",
      code: "metadata",
      Cell: ({ cell }) => (cell?.shipping ? cell.shipping : ""),
      index: "8",
    },
    {
      width: 80,
      text: "입금액",
      justifyContent: "flex-start",
      code: "payments",
      Cell: ({ cell }) => cell?.[0]?.amount || 0,
      index: "9",
    },
    {
      width: 80,
      text: "입금은행",
      justifyContent: "center",
      Cell: () => `무통장/국민은행`,
      index: "10",
    },
    {
      width: 80,
      text: "추가입금",
      justifyContent: "center",
      Cell: () => "-",
      index: "11",
    },
    {
      width: 80,
      text: "총 결제금액",
      justifyContent: "flex-start",
      code: "payments",
      Cell: ({ cell }) => cell?.[0]?.amount || 0,
      index: "12",
    },
    {
      width: 140,
      text: "배송정보",
      justifyContent: "flex-start",
      code: "shipping_address",
      Cell: ({ cell }) =>
        `${cell?.company ? cell.company : ""}${
          cell?.company &&
          cell?.company !== "default" &&
          (cell?.first_name || cell?.last_name)
            ? " "
            : ""
        }${
          cell?.first_name || cell?.last_name
            ? `${cell?.first_name && cell.first_name}${
                cell.first_name && cell.last_name ? " " : ""
              }${cell.last_name ? cell.last_name : ""}`
            : ""
        } ${cell?.postal_code ? `(${cell.postal_code})` : ""}${
          cell?.postal_code && (cell?.address_1 || cell.address_2) ? " " : ""
        }${cell?.address_1 ? cell.address_1 : ""}${
          cell.address_1 && cell.address_2 ? " " : ""
        }${cell?.address_2 ? cell.address_2 : ""}`.replace("default ", ""),

      index: "13",
    },
  ];
  const getOutput = (outputHeader) => {
    const output = async (data, indexes) => {
      let list;
      if (!indexes || indexes.length === 0) {
        list =
          (
            await adminRequester.getOrderStatus({
              ...extraCondition,
              ...searchCondition,
            })
          ).orders || [];
      } else {
        list = indexes.map((index) => ({
          ...data[index],
          // index: index + page * limit,
        }));
      }
      return {
        header: outputHeader,
        list: list,
        fileName: `주문_${new Date().getTime()}`,
      };
    };
    return output;
  };
  const openDetail = ({ row }) => {
    NiceModal.show("orderDetail", {
      data: row,
      onSuccess: () => setResearch(true),
    });
  };
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            {views.map((view) => (
              <FlexChild width="max-content">
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    fontSize: 18,
                    paddingBottom: "8px",
                    fontWeight: "700",
                  }}
                  className={clsx({
                    [style.clickable]: views.length > 1 && view !== keyword,
                    [style.selected]: view === keyword && views.length > 1,
                  })}
                  onClick={() => {
                    if (views.length > 0 && view !== keyword)
                      navigator(`/admin/orderStatus/${view}`);
                  }}
                >
                  {t(view)}
                </div>
              </FlexChild>
            ))}
          </HorizontalFlex>
        </FlexChild>
        <FlexChild>
          <TableSearchCard
            keyword={keyword}
            callback={callback}
            index={4}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <VerticalFlex>
            <FlexChild padding={20}>
              <select
                style={{ marginLeft: "auto" }}
                onClick={(e) => {
                  setLimit(Number(e.target.value));
                  setResearch(true);
                }}
              >
                <option value={20}>20개</option>
                <option value={50}>50개</option>
                <option value={100}>100개</option>
                <option value={200}>200개</option>
              </select>
            </FlexChild>

            <FlexChild>
              <SingleAdminTable
                keyword={keyword}
                theader={theader}
                mockData={data}
                initTabIndex={0}
                callback={dataCallback}
                buttons={buttons}
                reset={reset}
                research={research}
                count={count}
                page={page}
                maxPage={maxPage}
                setPage={setPage}
                limit={limit}
                output={outs}
              />
            </FlexChild>
          </VerticalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default OrderStatusDetail;

// export const Memo = ({ cell, row, setResearch }) => {
//   const [isOpen, setOpen] = useState(false);
//   const [edit, setEdit] = useState(false);
//   const input = useRef();
//   return (
//     <div style={{ position: "relative" }}>
//       <AdminCustomButton
//         style={buttonStyle.white_border}
//         onClick={() => setOpen(!isOpen)}
//         text="메모"
//       />
//       {isOpen && (
//         <div
//           style={{
//             position: "absolute",
//             minWidth: "10vw",
//             minHeight: "10vh",
//             width: "max-content",
//             height: "max-content",
//             background: "#FFFFFF",
//             borderWidth: 1,
//             borderStyle: "solid",
//             borderColor: "gray",
//             borderRadius: 10,
//             right: "120%",
//             top: "-50%",
//             padding: 10,
//           }}
//         >
//           <VerticalFlex gap={10}>
//             <InputTextarea
//               validable={false}
//               ref={input}
//               style={{ fontSize: 12, border: edit ? null : "none" }}
//               rows={5}
//               name="메모"
//               readOnly={!edit}
//               value={cell?.memo}
//             />
//             <HorizontalFlex justifyContent="center" gap={10}>
//               {edit ? (
//                 <>
//                   <AdminCustomButton
//                     text="저장"
//                     onClick={() => {
//                       setEdit(false);
//                       const metadata = _.merge(cell, {
//                         memo: input.current.getValue(),
//                       });
//                       adminRequester.updateOrderStatus(
//                         row.id,
//                         {
//                           metadata: metadata,
//                         },
//                         () => setResearch(true)
//                       );
//                     }}
//                   />
//                   <AdminCustomButton
//                     text="취소"
//                     onClick={() => {
//                       setEdit(false);
//                       input.current.setValue(cell.memo);
//                     }}
//                   />
//                 </>
//               ) : (
//                 <>
//                   <AdminCustomButton
//                     text="편집"
//                     onClick={() => setEdit(true)}
//                   />
//                   <AdminCustomButton
//                     text="닫기"
//                     onClick={() => setOpen(false)}
//                   />
//                 </>
//               )}
//             </HorizontalFlex>
//           </VerticalFlex>
//         </div>
//       )}
//     </div>
//   );
// };
export const Memo = ({ cell, row, setResearch }) => {
  const [isOpen, setOpen] = useState(false);
  const input = useRef();
  return (
    <div style={{ position: "relative" }}>
      {/* <AdminCustomButton
        style={buttonStyle.white_border}
        onClick={() => setOpen(!isOpen)}
        text="메모"
      /> */}
      <P
        textHover
        cursor
        color={cell.memo && "red"}
        onClick={() => setOpen(!isOpen)}
      >
        {cell.memo ? cell.memo : "없음"}
      </P>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            minWidth: "10vw",
            minHeight: "10vh",
            width: "max-content",
            height: "max-content",
            background: "#FFFFFF",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "gray",
            borderRadius: 10,
            right: "120%",
            top: "-50%",
            padding: 10,
          }}
        >
          <VerticalFlex gap={10}>
            <InputTextarea
              validable={false}
              ref={input}
              style={{ fontSize: 12 }}
              rows={5}
              name="메모"
              value={cell?.memo}
            />
            <HorizontalFlex justifyContent="center" gap={10}>
              {
                <>
                  <AdminCustomButton
                    text="저장"
                    onClick={() => {
                      setOpen(!isOpen);
                      const metadata = _.merge(cell, {
                        memo: input.current.getValue(),
                      });
                      adminRequester.updateOrderStatus(
                        row.id,
                        {
                          metadata: metadata,
                        },
                        () => setResearch(true)
                      );
                    }}
                  />
                  <AdminCustomButton
                    text="취소"
                    onClick={() => {
                      setOpen(!isOpen);
                      input.current.setValue(cell.memo);
                    }}
                  />
                </>
              }
            </HorizontalFlex>
          </VerticalFlex>
        </div>
      )}
    </div>
  );
};
